<template>
  <div class="dashboard-container">
    <div class="mb-2 page-title">
      <i class="bi bi-diagram-3"></i> Jenis &amp; Tarif Pertandingan
    </div>

    <!-- Pilih acara -->
    <section class="ui-card jt__blok">
      <div class="ui-card__body">
        <label class="ui-field">
          <span class="ui-label">Pilih Acara / Turnamen</span>
          <select v-model="tournamentId" class="ui-input" @change="muatSemua">
            <option value="">-- Pilih Turnamen --</option>
            <option v-for="t in turnamen" :key="t.id" :value="t.id">{{ t.name }}</option>
          </select>
        </label>
        <div v-if="turnamenTerpilih" class="mt-2 text-success fw-semibold">
          <i class="bi bi-trophy-fill text-warning me-1"></i>
          Turnamen Aktif: <strong>{{ turnamenTerpilih.name }}</strong>
          <span v-if="turnamenTerpilih.location" class="text-muted fw-normal ms-1">({{ turnamenTerpilih.location }})</span>
        </div>
        <p class="jt__teks mt-2">
          Jenis pertandingan dan tarif pendaftaran diatur <strong>khusus per turnamen</strong>.
        </p>
      </div>
    </section>

    <template v-if="tournamentId">
      <!-- Seksi 1: Jenis Pertandingan -->
      <section class="ui-card jt__blok">
        <div class="ui-card__body">
          <h2 class="jt__judul">
            <span class="jt__nomor">1</span> Jenis Pertandingan — <span class="text-primary">{{ turnamenTerpilih?.name }}</span>
          </h2>
          <p class="jt__teks">
            Atur jenis untuk <strong>Tanding</strong> (mis. Pemasalan, Prestasi) dan
            <strong>Seni</strong> (mis. Tunggal, Ganda, Regu, Solo Kreatif) secara terpisah.
            Daftar ini yang muncul saat official mendaftarkan atlet.
          </p>

          <!-- Tanding jenis -->
          <div class="jt__sub-jenis">
            <div class="jt__sub-judul">
              <i class="bi bi-shield-fill-check text-primary"></i> Tanding
            </div>
            <form class="jt__baris-tambah" @submit.prevent="tambahJenis(1)">
              <input
                v-model.trim="jenisTandingBaru"
                class="ui-input"
                type="text"
                placeholder="mis. Pemasalan, Prestasi"
                maxlength="100"
              />
              <button type="submit" class="ui-btn ui-btn--secondary" :disabled="!jenisTandingBaru || sibuk">
                <i class="bi bi-plus-lg"></i> Tambah
              </button>
            </form>
            <ul v-if="jenisTandingList.length" class="jt__daftar">
              <li v-for="j in jenisTandingList" :key="j.id" class="jt__item">
                <span class="jt__badge jt__badge--tanding">Tanding</span>
                <input v-model.trim="j.name" class="ui-input jt__item-nama" maxlength="100" @change="ubahJenis(j)" />
                <button type="button" class="ui-btn ui-btn--sm aksi__item--bahaya" :disabled="sibuk" @click="hapusJenis(j)">
                  <i class="bi bi-trash"></i>
                </button>
              </li>
            </ul>
            <p v-else class="jt__kosong">Belum ada jenis Tanding.</p>
          </div>

          <!-- Seni jenis -->
          <div class="jt__sub-jenis mt-3">
            <div class="jt__sub-judul">
              <i class="bi bi-stars text-warning"></i> Seni
            </div>
            <form class="jt__baris-tambah" @submit.prevent="tambahJenis(2)">
              <input
                v-model.trim="jenisSeniBaru"
                class="ui-input"
                type="text"
                placeholder="mis. Tunggal, Ganda, Regu, Solo Kreatif"
                maxlength="100"
              />
              <button type="submit" class="ui-btn ui-btn--secondary" :disabled="!jenisSeniBaru || sibuk">
                <i class="bi bi-plus-lg"></i> Tambah
              </button>
            </form>
            <ul v-if="jenisSeniList.length" class="jt__daftar">
              <li v-for="j in jenisSeniList" :key="j.id" class="jt__item">
                <span class="jt__badge jt__badge--seni">Seni</span>
                <input v-model.trim="j.name" class="ui-input jt__item-nama" maxlength="100" @change="ubahJenis(j)" />
                <button type="button" class="ui-btn ui-btn--sm aksi__item--bahaya" :disabled="sibuk" @click="hapusJenis(j)">
                  <i class="bi bi-trash"></i>
                </button>
              </li>
            </ul>
            <p v-else class="jt__kosong">Belum ada jenis Seni. Tambahkan: Tunggal, Ganda, Regu, atau Solo Kreatif.</p>
          </div>
        </div>
      </section>

      <!-- Seksi 2: Tarif Pendaftaran -->
      <section class="ui-card jt__blok">
        <div class="ui-card__body">
          <h2 class="jt__judul">
            <span class="jt__nomor">2</span> Tarif Pendaftaran — <span class="text-primary">{{ turnamenTerpilih?.name }}</span>
          </h2>
          <p class="jt__teks">
            Biaya per atlet, ditentukan dari <strong>Tanding/Seni + Jenis + Kelompok Usia</strong>.
            Kosongkan Kelompok Usia kalau tarifnya sama untuk semua usia.
          </p>

          <form class="jt__form-tarif" @submit.prevent="tambahTarif">
            <label class="ui-field">
              <span class="ui-label">Tanding / Seni</span>
              <select v-model="tarifBaru.championship_category_id" class="ui-input" required @change="tarifBaru.jenis_pertandingan_id = null">
                <option value="">Pilih</option>
                <option v-for="k in kejuaraan" :key="k.id" :value="k.id">{{ k.name }}</option>
              </select>
            </label>

            <label class="ui-field">
              <span class="ui-label">Jenis</span>
              <select v-model="tarifBaru.jenis_pertandingan_id" class="ui-input">
                <option :value="null">Semua jenis</option>
                <option v-for="j in jenisFiltered" :key="j.id" :value="j.id">{{ j.name }}</option>
              </select>
            </label>

            <label class="ui-field">
              <span class="ui-label">Kelompok Usia</span>
              <select v-model="tarifBaru.age_category_id" class="ui-input">
                <option :value="null">Semua kelompok usia</option>
                <option v-for="u in usia" :key="u.id" :value="u.id">{{ u.name }}</option>
              </select>
            </label>

            <label class="ui-field">
              <span class="ui-label">Biaya (Rp)</span>
              <input v-model.number="tarifBaru.biaya" class="ui-input" type="number" min="0" step="1000" required />
            </label>

            <button type="submit" class="ui-btn ui-btn--secondary" :disabled="sibuk">
              <i class="bi bi-plus-lg"></i> Tambah Tarif
            </button>
          </form>

          <div v-if="tarifList.length" class="jt__tabel-bungkus">
            <table class="jt__tabel">
              <thead>
                <tr>
                  <th>Turnamen</th>
                  <th>Tanding / Seni</th>
                  <th>Jenis</th>
                  <th>Kelompok Usia</th>
                  <th class="jt__kanan">Biaya</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="t in tarifList" :key="t.id">
                  <td><strong>{{ turnamenTerpilih?.name || '-' }}</strong></td>
                  <td>{{ t.championship_category?.name || '-' }}</td>
                  <td>{{ t.jenis_pertandingan?.name || 'Semua jenis' }}</td>
                  <td>{{ t.age_category?.name || 'Semua usia' }}</td>
                  <td class="jt__kanan">{{ rupiah(t.biaya) }}</td>
                  <td class="jt__kanan">
                    <button
                      type="button"
                      class="ui-btn ui-btn--sm aksi__item--bahaya"
                      :disabled="sibuk"
                      @click="hapusTarif(t)"
                    >
                      <i class="bi bi-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p v-else class="jt__kosong">
            Belum ada tarif. Selama kosong, sistem memakai biaya lama dari menu
            Kategori Turnamen — dan atlet yang tidak punya biaya di sana tidak
            bisa ditagih.
          </p>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import http from '@/services/http';
import { useToast } from 'vue-toastification';

export default {
  name: 'JenisTarifPage',

  setup() {
    return { toast: useToast() };
  },

  data() {
    return {
      turnamen: [],
      kejuaraan: [],
      usia: [],
      tournamentId: '',
      jenisList: [],      // semua jenis (untuk referensi)
      tarifList: [],
      jenisTandingBaru: '',
      jenisSeniBaru: '',
      tarifBaru: this.tarifKosong(),
      sibuk: false,
    };
  },

  created() {
    this.muatAwal();
  },

  methods: {
    tarifKosong() {
      return {
        championship_category_id: '',
        jenis_pertandingan_id: null,
        age_category_id: null,
        biaya: null,
      };
    },

    /** Balasan kadang dibungkus {data:[...]}, kadang array polos. */
    isi(r) {
      const d = r?.data;
      return Array.isArray(d) ? d : (d?.data ?? []);
    },

    rupiah(n) {
      return 'Rp ' + Number(n || 0).toLocaleString('id-ID');
    },

    async muatAwal() {
      try {
        let tData = [];
        try {
          const t = await http.get('/tournaments', { params: { fetch_all: true } });
          tData = this.isi(t);
        } catch (e) {
          console.warn('Gagal memuat /tournaments', e);
        }

        if (!tData || !tData.length) {
          try {
            const t3 = await http.get('/tournaments/all');
            tData = this.isi(t3);
          } catch (e) {
            console.warn('Gagal memuat /tournaments/all', e);
          }
        }

        const [k, u] = await Promise.all([
          http.get('/championship-categories').catch(() => ({ data: [] })),
          http.get('/age-categories').catch(() => ({ data: [] })),
        ]);

        this.turnamen = tData || [];
        this.kejuaraan = this.isi(k);
        this.usia = this.isi(u);

        // Pilih otomatis turnamen pertama jika ada
        if (this.turnamen.length > 0 && !this.tournamentId) {
          this.tournamentId = this.turnamen[0].id;
          await this.muatSemua();
        }
      } catch (e) {
        this.toast.error('Gagal memuat data awal.');
      }
    },

    async muatSemua() {
      this.jenisList = [];
      this.tarifList = [];
      this.tarifBaru = this.tarifKosong();

      if (!this.tournamentId) return;

      try {
        const [j, t] = await Promise.all([
          http.get('/jenis-pertandingan', { params: { tournament_id: this.tournamentId } }),
          http.get('/tarif-pendaftaran', { params: { tournament_id: this.tournamentId } }),
        ]);

        this.jenisList = this.isi(j);
        this.tarifList = this.isi(t);
      } catch (e) {
        this.toast.error('Gagal memuat jenis dan tarif.');
      }
    },

    async tambahJenis(championshipCategoryId) {
      const name = championshipCategoryId === 1 ? this.jenisTandingBaru : this.jenisSeniBaru;
      if (!name) return;

      this.sibuk = true;
      try {
        await http.post('/jenis-pertandingan', {
          tournament_id: this.tournamentId,
          name,
          championship_category_id: championshipCategoryId,
        });
        if (championshipCategoryId === 1) this.jenisTandingBaru = '';
        else this.jenisSeniBaru = '';
        await this.muatSemua();
        this.toast.success('Jenis ditambahkan.');
      } catch (e) {
        this.toast.error(e?.response?.data?.message || 'Gagal menambah jenis.');
      } finally {
        this.sibuk = false;
      }
    },

    async ubahJenis(j) {
      try {
        await http.put(`/jenis-pertandingan/${j.id}`, { name: j.name });
        this.toast.success('Nama jenis disimpan.');
      } catch (e) {
        this.toast.error(e?.response?.data?.message || 'Gagal menyimpan.');
        await this.muatSemua();
      }
    },

    /*
     * Penghapusan bisa ditolak server kalau jenisnya masih dipakai atlet.
     * Pesannya diteruskan apa adanya — di situ ada jumlah atlet yang
     * terpengaruh, dan itu yang menentukan langkah panitia berikutnya.
     */
    async hapusJenis(j) {
      if (!window.confirm(`Hapus jenis "${j.name}"?`)) return;

      this.sibuk = true;
      try {
        await http.delete(`/jenis-pertandingan/${j.id}`);
        await this.muatSemua();
        this.toast.success('Jenis dihapus.');
      } catch (e) {
        this.toast.error(e?.response?.data?.message || 'Gagal menghapus jenis.');
      } finally {
        this.sibuk = false;
      }
    },

    async tambahTarif() {
      this.sibuk = true;
      try {
        await http.post('/tarif-pendaftaran', {
          tournament_id: this.tournamentId,
          ...this.tarifBaru,
        });
        this.tarifBaru = this.tarifKosong();
        await this.muatSemua();
        this.toast.success('Tarif ditambahkan.');
      } catch (e) {
        this.toast.error(e?.response?.data?.message || 'Gagal menambah tarif.');
      } finally {
        this.sibuk = false;
      }
    },

    async hapusTarif(t) {
      if (!window.confirm('Hapus baris tarif ini?')) return;

      this.sibuk = true;
      try {
        await http.delete(`/tarif-pendaftaran/${t.id}`);
        await this.muatSemua();
        this.toast.success('Tarif dihapus.');
      } catch (e) {
        this.toast.error(e?.response?.data?.message || 'Gagal menghapus tarif.');
      } finally {
        this.sibuk = false;
      }
    },
  },
  computed: {
    turnamenTerpilih() {
      return this.turnamen.find((t) => String(t.id) === String(this.tournamentId)) || null;
    },
    /** Jenis khusus Tanding (championship_category_id = 1) atau null (semua) */
    jenisTandingList() {
      return this.jenisList.filter(
        (j) => j.championship_category_id === 1 || j.championship_category_id === null
      );
    },
    /** Jenis khusus Seni (championship_category_id = 2) atau null (semua) */
    jenisSeniList() {
      return this.jenisList.filter(
        (j) => j.championship_category_id === 2 || j.championship_category_id === null
      );
    },
    /**
     * Jenis yang muncul di dropdown form tarif, difilter berdasarkan
     * Tanding/Seni yang sedang dipilih pada form tambah tarif.
     */
    jenisFiltered() {
      const catId = Number(this.tarifBaru.championship_category_id);
      if (!catId) return this.jenisList;
      return this.jenisList.filter(
        (j) => j.championship_category_id === catId || j.championship_category_id === null
      );
    },
  },
};
</script>

<style scoped>
.page-title {
  font-size: 1.5rem;
  font-weight: bold;
}

.jt__blok {
  margin-bottom: 1.25rem;
}

.jt__judul {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.jt__nomor {
  display: inline-grid;
  place-items: center;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 50%;
  background: var(--grad-flame, #ea580c);
  color: #fff;
  font-size: 0.9rem;
}

.jt__teks {
  font-size: 0.9rem;
  line-height: 1.55;
  color: var(--text-secondary, #6b7280);
  margin-bottom: 1rem;
}

.jt__baris-tambah {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.jt__baris-tambah .ui-input {
  flex: 1 1 220px;
}

.jt__daftar {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 0.5rem;
}

.jt__item {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.jt__item-nama {
  flex: 1 1 auto;
}

.jt__kosong {
  font-size: 0.9rem;
  color: #b45309;
  background: rgba(217, 119, 6, 0.1);
  padding: 0.65rem 0.8rem;
  border-radius: 8px;
  line-height: 1.5;
}

.jt__form-tarif {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.75rem;
  align-items: end;
  margin-bottom: 1.25rem;
}

.jt__tabel-bungkus {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  max-width: 100%;
}

.jt__tabel {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.jt__tabel th,
.jt__tabel td {
  padding: 0.55rem 0.6rem;
  border-bottom: 1px solid var(--border-color, #e5e7eb);
  text-align: left;
  white-space: nowrap;
}

.jt__kanan {
  text-align: right;
}

.jt__sub-jenis {
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 8px;
  padding: 0.8rem 1rem;
}

.jt__sub-judul {
  font-weight: 600;
  font-size: 0.95rem;
  margin-bottom: 0.6rem;
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.jt__badge {
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  white-space: nowrap;
  flex-shrink: 0;
}

.jt__badge--tanding {
  background: rgba(59, 130, 246, 0.12);
  color: #1d4ed8;
}

.jt__badge--seni {
  background: rgba(234, 179, 8, 0.12);
  color: #b45309;
}
</style>
